import { assignInlineVars } from '@vanilla-extract/dynamic';
import React, { ReactNode } from 'react';

import {
	barClass,
	barRate,
	barWrapperClass,
	containerClass,
	innerClass,
	itemClass,
	labelClass,
	textContainerClass,
	valueClass,
} from './style.css';
import ColoredChartText from '../colored-chart-text/ColoredChartText';

export interface HorizontalRateChartDataItem {
	label?: string;
	value?: string;
	isPositive?: boolean;
	valuePercentage?: number;
}

export interface HorizontalRateChartProps {
	desc?: ReactNode;
	subDesc?: string;
	data?: HorizontalRateChartDataItem[];
	align?: 'vertical' | 'horizontal';

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const HorizontalRateChart = ({
	desc,
	subDesc,
	align = 'vertical',
	isLoading,
	isError,
	lackOfPermission,
	...props
}: HorizontalRateChartProps) => {
	const data: HorizontalRateChartProps['data'] =
		isLoading || isError
			? [{ label: '?', value: '?', valuePercentage: 0 }]
			: props.data
			? lackOfPermission
				? props.data.map((data) => ({
						...data,
						label: 'example',
						value: '50%',
						valuePercentage: 50,
				  }))
				: props.data
			: [];

	return (
		<div className={containerClass({ align })}>
			{desc && (
				<ColoredChartText
					subText={subDesc}
					isLoading={isLoading}
					isError={isError}
					lackOfPermission={lackOfPermission}
				>
					{desc}
				</ColoredChartText>
			)}

			<div className={innerClass}>
				{data?.map((item, idx) => (
					<div key={idx} className={itemClass}>
						<div className={textContainerClass}>
							<div className={labelClass}>{item?.label}</div>
							<div className={valueClass}>{item?.value}</div>
						</div>

						<div className={barWrapperClass}>
							<div
								className={barClass({ isPositive: item.isPositive })}
								style={assignInlineVars({ [barRate]: `${item.valuePercentage}%` })}
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default HorizontalRateChart;
